const styles = ({ forms }) => ({
  margin: [0, 'auto'],
  maxWidth: forms.maxWidth,
});

export default styles;
